import { TextField, withStyles } from "@material-ui/core";

export default withStyles(theme => ({
  root: {
    "& .MuiOutlinedInput-root": {
      fontSize: theme.typography.body1.fontSize,
      margin: theme.spacing(1, 0),
      padding: theme.spacing(1, 0),
      minHeight: ({ multiline }) => (multiline ? 80 : theme.spacing(3)),
      "& fieldset": {
        border: "none",
        borderBottom: `1px ${theme.palette.lines.divisionLight} solid`,
        borderRadius: 0
      }
    },
    "& .MuiOutlinedInput-input": {
      padding: theme.spacing(0.5, 1),
      minHeight: ({ multiline }) => (multiline ? 160 : theme.spacing(3)),
      backgroundColor: theme.palette.text.superLight,
      color: ({ disabled }) =>
        disabled ? theme.palette.text.mildLight : theme.palette.text.dark
    },
    "& .MuiOutlinedInput-multiline": {
      padding: theme.spacing(0)
    }
  }
}))(TextField);
